var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrievanceRedressalTopLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 917,
    height: 4,
    viewBox: "0 0 917 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.556624 1.75L2 3.19338L3.44338 1.75L2 0.306624L0.556624 1.75ZM916.443 1.75L915 0.306624L913.557 1.75L915 3.19338L916.443 1.75ZM2 2H915V1.5H2V2Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrievanceRedressalTopLine);
export default __webpack_public_path__ + "static/media/grievance-redressal-top-line.c4db1f29f96872c96f4e32603803265b.svg";
export { ForwardRef as ReactComponent };